import { type SelectInputProps, SelectInput } from "react-admin";

const PROTOCOL_CSV_CHOICES = [
  {
    id: "IPSEC",
    name: "IPSEC",
  },
  {
    id: "HTTPS",
    name: "HTTPS",
  },
  {
    id: "HTTPS,IPSEC",
    name: "HTTPS, IPSEC",
  },
];

export const RadiusVpnServerProtocolCsvInput = (
  props: Omit<SelectInputProps, "choices">,
) => (
  <SelectInput
    {...props}
    choices={PROTOCOL_CSV_CHOICES}
    defaultValue={PROTOCOL_CSV_CHOICES[0].id}
  />
);
